(ns com.theplantscape.web-ui.tailwind.buttons
  (:require [reitit.frontend.easy :as rfe]
            ))

(defn ui-btn-link [{:keys [text href] :as cfg}]
  [:a.ui-btn-dark
  {:href href :class (:class cfg)} text])

(defn ui-btn-action [text callback]
  [:button.ui-btn
  {:on-click callback}
   text])


(defn btn-add-new-plant []
  [:a.py-3.lg:py-4.px-6.lg:px-6.text-white-500.font-semibold.rounded-lg.bg-green-500.hover:shadow-orange-md.transition-all.outline-none
  {:href (rfe/href :plant-add)}
   [:i.fas.fa-leaf.fl.mr3.mt1]
  "Add new plant"])

(defn ui-btn-toggle [state update-fn]
  [:button.relative.rounded..hover:bg-emerald-500.rounded-full.h-8.w-14 ;.left-8
   {:on-click update-fn
    :class (if (true? state) "bg-emerald-400" "bg-emerald-300")}
   [:div.absolute.rounded-full.bg-emerald-800.w-8.h-8.top-0
    {:class (if (true? state) "left-0 " "left-6")}]])
